import React, { FC } from 'react';
import { IResourceComponentsProps } from '@refinedev/core';
import { useTable, List } from '@refinedev/antd';
import { Table } from 'antd';
import '../styles/index.css';

export const CurrenciesList: FC<IResourceComponentsProps> = () => {
  const { tableProps } = useTable({
    syncWithLocation: true,
  });

  return (
    <List title='Currencies Directory'>
      <Table {...tableProps} rowKey='id'>
        <Table.Column dataIndex='code' title='Currency Code' />
        <Table.Column dataIndex='name' title='Currency Name' />
      </Table>
    </List>
  );
};
